import { useContext, useEffect, 
} from "react";
import { Ratio1Set, Ratio2Set } from "../../App";

export function Modalratio0set({ show, setShow }) {
  const { ratio1set, setRatio1Set } = useContext(Ratio1Set);
  const { ratio2set, setRatio2Set } = useContext(Ratio2Set);

  const onChange = (event) => {
    setRatio1Set(event.target.value);
  }
  
  useEffect(()=>{
    setRatio2Set(ratio1set);
  },[ratio1set])

  if (show) {
    return (
      <>
        <div
          id="overlay"
          onClick={() => setShow(false)}
          className="top-0 left-0 w-screen h-screen z-50 bg-gradient-to-r from-black/40 to-black/60"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="max-h-[70vh] overflow-y-auto w-full md:w-1/2 lg:w-1/4 bg-gradient-to-r from-black/80 via-black/80 to-black/70 rounded-lg"
          >
            <div onClick={()=>setShow(false)} className="flex justify-end mt-2 mr-2 cursor-pointer text-white">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>

            <div>
              <div>
                <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-4 pb-8 rounded-lg">
                  <div className="text-center pb-6">
                    <h1 className="font-bold text-xl md:text-2xl lg:text-3xl font-heading text-gray-100">
                      高さ設定
                    </h1>

                    <div>
                      <>
                        <div className="py-4 text-white" style={{ zIndex: "1000" }}>
                          <span className="font-bold text-xl md:text-2xl lg:text-3xl">
                            {ratio1set}倍
                          </span>
                        </div>

                        <div className="py-2" style={{ zIndex: "1000" }}>
                          <span style={{ color: "white" }}>
                            縮小（0.0-1.0）
                          </span>
                          <input
                            type="range"
                            id="input_volume"
                            name="upload_file"
                            min="0"
                            max="1"
                            step="0.1"
                            list="tickmarks1"
                            style={{ color: "white" }}
                            value={ratio1set}
                            onChange={onChange}
                          />
                          <datalist id="tickmarks1">
                            <option value="0" label="1">
                              0
                            </option>
                            <option value="1" label="1">
                              1
                            </option>
                          </datalist>
                        </div>
                        <div className="py-2" style={{ zIndex: "1000" }}>
                          <span style={{ color: "white" }}>
                            拡大（ 1 - 10 ）
                          </span>
                          <input
                            type="range"
                            id="input_volume"
                            name="upload_file"
                            min="1"
                            max="10"
                            step="1"
                            list="tickmarks2"
                            style={{ color: "white" }}
                            value={ratio1set}
                            onChange={onChange}
                          />
                          <datalist id="tickmarks2">
                            <option value="1" label="1">
                              1
                            </option>
                            <option value="10" label="5">
                              10
                            </option>
                          </datalist>
                        </div>
                        <div>
                        <button
                          onClick={() => setRatio1Set(0.5)}
                          className="relative inline-flex items-center justify-center p-0.5 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-cyan-500 to-blue-500 group-hover:from-cyan-500 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:ring-cyan-200 dark:focus:ring-cyan-800 mt-5 mx-1"
                        >
                          <span className="relative px-1 py-1 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
                            0.5倍
                          </span>
                        </button>
                        <button
                          onClick={() => setRatio1Set(1)}
                          className="relative inline-flex items-center justify-center p-0.5 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-cyan-500 to-blue-500 group-hover:from-cyan-500 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:ring-cyan-200 dark:focus:ring-cyan-800 mt-5 mx-1"
                        >
                          <span className="relative px-1 py-1 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
                            １倍
                          </span>
                        </button>
                        <button
                          onClick={() => setRatio1Set(2)}
                          className="relative inline-flex items-center justify-center p-0.5 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-cyan-500 to-blue-500 group-hover:from-cyan-500 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:ring-cyan-200 dark:focus:ring-cyan-800 mt-5 mx-1"
                        >
                          <span className="relative px-1 py-1 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
                            ２倍
                          </span>
                        </button>
                        <button
                          onClick={() => setRatio1Set(5)}
                          className="relative inline-flex items-center justify-center p-0.5 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-cyan-500 to-blue-500 group-hover:from-cyan-500 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:ring-cyan-200 dark:focus:ring-cyan-800 mt-5 mx-1"
                        >
                          <span className="relative px-1 py-1 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
                            ５倍
                          </span>
                        </button>
                        </div>
                      </>
                    </div>
                  </div>
                  <button
                    onClick={() => setShow(false)}
                    className="relative inline-flex items-center justify-center p-0.5 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-cyan-500 to-blue-500 group-hover:from-cyan-500 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:ring-cyan-200 dark:focus:ring-cyan-800"
                  >
                    <span className="relative px-5 py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
                      設定完了
                    </span>
                  </button>
                </section>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return null;
  }
}
